export default __webpack_public_path__ + "static/media/typescript.f66836b8.svg";